document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "undefined") {
    return;
  }

  // Sass の m.vw() と同じ基準で、Swiper に渡す px 値を算出する。
  const pcMediaQuery = window.matchMedia("(min-width: 769px)");
  const getVw = (pixels) => {
    // CSS 変数 --vw-base は PC/SP で Sass 側と同じ値に切り替わる。
    const vwBase = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--vw-base"));

    return pixels * (window.innerWidth / (vwBase || (pcMediaQuery.matches ? 1440 : 390)));
  };
  const getResponsiveVw = (spPixels, pcPixels) => {
    return getVw(pcMediaQuery.matches ? pcPixels : spPixels);
  };

  // リサイズ時に spaceBetween を再計算し、Swiper の設定値にも反映する。
  const updateSliderSpace = (swiper, spPixels, pcPixels) => {
    const spaceBetween = getResponsiveVw(spPixels, pcPixels);
    swiper.params.spaceBetween = spaceBetween;
    swiper.originalParams.spaceBetween = spaceBetween;
    Object.values(swiper.originalParams.breakpoints || {}).forEach((breakpoint) => {
      breakpoint.spaceBetween = spaceBetween;
    });
    swiper.update();
  };

  // リサイズ時に spaceBetween を更新する Swiper インスタンスを保持する。
  const responsiveSliders = [];

  // メインビジュアルのスライダーを初期化する。
  const mvSlider = document.querySelector(".mv_slider .swiper");
  if (mvSlider) {
    const mvAutoplayDelay = 4500;
    const mvSwiper = new Swiper(mvSlider, {
      loop: true,
      centeredSlides: true,
      fadeEffect: {
        crossFade: true,
      },
      speed: 1200,
      autoplay: {
        delay: mvAutoplayDelay,
        disableOnInteraction: false,
      },
      slidesPerView: 1.35,
      spaceBetween: getResponsiveVw(18, 169),
      breakpoints: {
        769: {
          slidesPerView: 1.53,
          spaceBetween: getResponsiveVw(18, 169),
        },
      },
      pagination: {
        el: ".mv_slider .swiper-pagination",
        clickable: true,
        bulletElement: "button",
        renderBullet(index, className) {
          return `
            <button class="${className}" type="button" aria-label="${index + 1}枚目のスライドを表示">
              <span class="mv_pagination_dot"></span>
              <svg class="mv_pagination_progress" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <circle class="mv_pagination_progress_track" cx="10" cy="10" r="9"></circle>
                <circle class="mv_pagination_progress_bar" cx="10" cy="10" r="9"></circle>
              </svg>
            </button>
          `;
        },
      },
      navigation: {
        nextEl: ".mv_slider .swiper-button-next",
        prevEl: ".mv_slider .swiper-button-prev",
      },
      on: {
        init(swiper) {
          swiper.el.closest(".mv_slider")?.style.setProperty("--mv-autoplay-delay", `${mvAutoplayDelay}ms`);
        },
      },
    });
    responsiveSliders.push({ swiper: mvSwiper, spPixels: 18, pcPixels: 169 });
  }

  // ニュース一覧のスライダーを初期化する。動的描画後にも呼べるように関数化する。
  const initNewsSlider = () => {
    const newsSlider = document.querySelector(".news_slider .swiper");
    if (!newsSlider || newsSlider.swiper) {
      return;
    }

    const newsSwiper = new Swiper(newsSlider, {
      loop: true,
      centeredSlides: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.56,
      spaceBetween: getResponsiveVw(20, 28),
      breakpoints: {
        769: {
          slidesPerView: 3.54,
          spaceBetween: getResponsiveVw(20, 28),
        },
      },
      navigation: {
        nextEl: ".news_slider .swiper-button-next",
        prevEl: ".news_slider .swiper-button-prev",
      },
    });
    responsiveSliders.push({ swiper: newsSwiper, spPixels: 20, pcPixels: 28 });
  };

  window.tryangleInitNewsSlider = initNewsSlider;

  if (document.querySelector("[data-home-news-slider-list]")) {
    document.addEventListener("tryangle:homeNewsRendered", initNewsSlider);
  } else {
    initNewsSlider();
  }

  if (responsiveSliders.length > 0) {
    let resizeFrame = null;
    window.addEventListener("resize", () => {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }
      resizeFrame = requestAnimationFrame(() => {
        responsiveSliders.forEach(({ swiper, spPixels, pcPixels }) => {
          updateSliderSpace(swiper, spPixels, pcPixels);
        });
      });
    });
  }
});
